module.exports = __webpack_public_path__ + "static/media/black-bg.4376a446.png";